import api from '@/lib/api';
import { ConversationResponse, ConversationThreadResponse, UpdateUseAiRequestDto } from '@/types/api';
import { debugNetworkRequest, debugApiError, debugConversation, debugConversationThread } from '@/utils/chatDebug';
import { chatLogger } from '@/utils/logger';

export const conversationService = {
  // Listar todas as conversas
  async getConversations(): Promise<ConversationResponse[]> {
    try {
      debugNetworkRequest('/conversations', 'GET');
      
      const response = await api.get<ConversationResponse[]>('/conversations');
      
      chatLogger.log('Conversas carregadas:', response.data.length);
      
      // Debug das primeiras conversas
      if (response.data.length > 0) {
        chatLogger.log('Primeira conversa:', response.data[0]);
        debugConversation(response.data[0]);
      }
      
      return response.data;
    } catch (error) {
      debugApiError(error, 'getConversations');
      throw error;
    }
  },

  // Buscar conversa por ID com mensagens
  async getConversationById(id: string): Promise<ConversationThreadResponse> {
    try {
      debugNetworkRequest(`/conversations/${id}`, 'GET');
      
      const response = await api.get<ConversationThreadResponse>(`/conversations/${id}`);
      
      chatLogger.log('Conversa carregada:', response.data.id);
      debugConversationThread(response.data);
      
      return response.data;
    } catch (error) {
      debugApiError(error, 'getConversationById');
      throw error;
    }
  },

  // Atualizar o campo useAi de uma conversa
  async updateUseAi(id: string, useai: boolean): Promise<ConversationResponse> {
    try {
      // Usar o DTO correto que corresponde ao UpdateUseAiRequestDto do backend
      const requestData: UpdateUseAiRequestDto = { useai };
      
      debugNetworkRequest(`/conversations/${id}/useai`, 'PATCH', requestData);
      
      const response = await api.patch<ConversationResponse>(`/conversations/${id}/useai`, requestData);
      
      chatLogger.log('UseAi atualizado:', { id, useai, result: response.data });
      
      return response.data;
    } catch (error) {
      debugApiError(error, 'updateUseAi');
      throw error;
    }
  },

  // Enviar mensagem manual
  async sendMessage(conversationId: string, message: string): Promise<void> {
    try {
      const requestData = { body: message };
      
      debugNetworkRequest(`/conversations/${conversationId}/send-message`, 'POST', requestData);
      
      await api.post(`/conversations/${conversationId}/send-message`, requestData);
      
      chatLogger.log('Mensagem enviada:', { conversationId, message });
    } catch (error) {
      debugApiError(error, 'sendMessage');
      throw error;
    }
  },
};
